import { ModalType } from './ModalType';

export class ModalModel {
    public Type: ModalType;
    public Title: string;
    public Body: string[];
    public InfoLinkBodyBeforeLink: string;
    public InfoLinkBodyAfterLink: string;
    public InfoLinkText: string;
    public InfoLink: string;
    public ActionYesText: string;
    public ActionNoText: string;
    public ActionOkText: string;
    public ActionYes: () => any;
    public ActionNo: () => any;
    public ActionOk: () => any;
}
